/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import InputWithLabel from './InputWithLabel';
import IconEyeShow from './icons/IconEyeShow';
import IconEyeHide from './icons/IconEyeHide';

class PasswordInput extends React.Component {

  constructor(props) {
    super(props);

    this.toggleShowPassword = this.toggleShowPassword.bind(this);

    this.state = {
      showPassword: false,
    };
  }

  toggleShowPassword() {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  }

  render() {
    const inputType = this.state.showPassword ? 'text' : 'password';
    const hideIcon = this.state.showPassword ? <IconEyeHide.Small /> : <IconEyeShow.Small />;

    return (
      <InputWithLabel
        {...this.props}
        type={inputType}
        autoComplete="off"
        style={{ paddingRight: 24 }}
        inputIconComponent={
          <span className="font-color-neutral is-clickable" onClick={this.toggleShowPassword}>
            {hideIcon}
          </span>
        }
      >
        {this.props.children}
      </InputWithLabel>
    );
  }
}
PasswordInput.propTypes = {
  children: PropTypes.any,
  hidePasswordTextId: PropTypes.string,
  showPasswordTextId: PropTypes.string,
};
PasswordInput.defaultProps = {
  hidePasswordTextId: 'pwdObfuscate.hide.button.hint',
  showPasswordTextId: 'pwdObfuscate.show.button.hint',
};

export default PasswordInput;
